import {
  assert
} from "./chunk-ZHIKNZLU.js";
import "./chunk-HBIFE4XN.js";

// src/number.ts
import BigNumber from "bignumber.js";
var hexEncodeNumber = (num) => `0x${num.toString(16)}`;
function formatUsdValue(value, precise = true) {
  if (value == null) return value;
  let usdAmount = new BigNumber(value);
  assert(usdAmount.gte(0), "negative amounts not supported");
  if (!usdAmount.eq(0) && usdAmount.lt(0.01)) return `<$0.01`;
  let suffix = "";
  let decimals = 2;
  if (!precise) {
    if (usdAmount.gte(1e12)) {
      usdAmount = usdAmount.shiftedBy(-12);
      suffix = "T";
    } else if (usdAmount.gte(1e9)) {
      usdAmount = usdAmount.shiftedBy(-9);
      suffix = "B";
    } else if (usdAmount.gte(1e6)) {
      usdAmount = usdAmount.shiftedBy(-6);
      suffix = "M";
    }
    if (suffix === "" && usdAmount.gte(1e4)) {
      decimals = 0;
    } else if (suffix !== "") {
      decimals = void 0;
    }
  }
  usdAmount = usdAmount.decimalPlaces(2);
  return `$${usdAmount.toFormat(decimals)}${suffix}`;
}
export {
  formatUsdValue,
  hexEncodeNumber
};
